"use client";

import { createElement, useContext } from "react";
import {
  Trans as TransOriginal,
  useTranslation as useTranslationsOriginal,
} from "react-i18next";
import { TranslatorContext } from "@/components/providers/translation-provider";

const DEFAULT_RICH_TRANSLATION_COMPONENTS = {
  br: createElement("br"),
};

export function useTranslation() {
  const { t: originalT, ...rest } = useTranslationsOriginal();
  const { showTranslationKeys } = useContext(TranslatorContext);

  const t = (key, options) => {
    if (showTranslationKeys) {
      return key;
    }
    return originalT(key, options);
  };

  return { t, ...rest };
}

export function RichTranslation({
  i18nKey,
  components = DEFAULT_RICH_TRANSLATION_COMPONENTS,
  ...props
}) {
  const { t } = useTranslation();

  return createElement(TransOriginal, {
    ...props,
    t,
    i18nKey,
    components,
  });
}
